import { render, staticRenderFns } from "./pieChart.vue?vue&type=template&id=83bea81e&scoped=true&"
import script from "./pieChart.vue?vue&type=script&lang=js&"
export * from "./pieChart.vue?vue&type=script&lang=js&"
import style0 from "./pieChart.vue?vue&type=style&index=0&id=83bea81e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bea81e",
  null
  
)

export default component.exports